var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrees4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 206,
    viewBox: "0 0 106 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees-4",
    transform: "translate(-495 -4251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2997",
    "data-name": "Rectangle 2997",
    d: "M53,0h53a0,0,0,0,1,0,0V53a53,53,0,0,1-53,53h0A53,53,0,0,1,0,53v0A53,53,0,0,1,53,0Z",
    transform: "translate(495 4251)",
    fill: "#c4d5c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3002",
    "data-name": "Rectangle 3002",
    width: 15,
    height: 151,
    rx: 7.5,
    transform: "translate(541 4306)",
    fill: "#57544e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees4);
export default __webpack_public_path__ + "static/media/trees-4.8cba448e98b3a4099a505744c29d8e92.svg";
export { ForwardRef as ReactComponent };